module.exports = __webpack_public_path__ + "static/S-Motion-ui-7936666df6fdf399b38e52b1e3f425b1.png";